interface IProps {
  title: string;
  onYesClick: () => void;
  onNoClick: () => void;
}

const ConfirmModalChild: React.FC<IProps> = ({
  title,
  onYesClick,
  onNoClick,
}) => {
  return (
    <>
      <div className="flex items-center justify-center">
        <div className="bg-white p-4">
          <p className="mb-4">{title}</p>
          <div className="flex justify-end">
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
              onClick={onYesClick}
            >
              Yes
            </button>
            <button
              className="bg-red-500 text-white px-4 py-2 rounded"
              onClick={onNoClick}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModalChild;
